<template>
  <div class="globalTopNav">
    <el-header>
      <div class="left">
        <img src="~@/assets/images/logo.png" alt="" />
        <slot name="mapNameLooker"></slot>
        <slot name="teamList"></slot>
      </div>
      <div class="center">
        <slot name="btn" v-if="!mapName"></slot>
        <div class="line" v-if="!mapName"></div>
        <div
          class="nav"
          v-for="(item, index) in visibleRoutes"
          :key="index"
          :class="activeIndex === index ? 'active' : ''"
          @click="changePath(index, item)"
        >
          <span v-if="!item.hidden">{{ item.meta.title }}</span>
        </div>
        <!-- <el-dropdown trigger="click" placement="bottom-start">
          <span class="el-dropdown-link"> 系统管理 </span>
          <el-dropdown-menu slot="dropdown">
            <div class="popover-content">
              <span @click="$router.push('/controlPlatform/dictManagement')"
                >字典管理</span
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown> -->
        <slot></slot>
      </div>
      <div class="right" v-if="!shared && !isTemplate">
        <Icon
          type="big"
          name="icon-help"
          @click.native="openHelp"
          content="帮助"
        ></Icon>
        <!-- 消息通知 -->
        <el-dropdown trigger="click" @visible-change="showInfoNotify" ref="dropdown">
          <Icon
            name="el-icon-bell"
            type="big"
            content="消息通知"
            :class="{ messageIcon: isHasOpertion || isHasVersion }"
          ></Icon>
          <el-dropdown-menu slot="dropdown">
            <div class="messageNotice">
              <!-- 导航 -->
              <div class="title">
                <div @click="switchMessage(1)">
                  <el-badge
                    :is-dot="isHasOpertion"
                    :class="['item', messageType === 1 ? 'active' : '']"
                    >操作日志</el-badge
                  >
                </div>
                <div @click="switchMessage(2)">
                  <el-badge
                    :is-dot="isHasVersion"
                    :class="['item', messageType === 2 ? 'active' : '']"
                    >版本更新</el-badge
                  >
                </div>
                <div
                  class="progress"
                  :style="{
                    transform:
                      messageType === 1
                        ? 'translateX(0px)'
                        : 'translateX(105px)',
                  }"
                ></div>
              </div>

              <!-- 操作日志 -->
              <div v-show="messageType === 1" class="operationCon">
                <div class="selectTypeCon">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="operationTypeValue"
                    placeholder="请选择"
                    @change="operationRefresh"
                  >
                    <el-option
                      v-for="item in operationIcons"
                      :key="item.name"
                      :label="item.name"
                      :value="item.module"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="contentCon" id="operateLogId">
                  <div class="isShow" v-if="operationData.length !== 0">
                    <div
                      class="item"
                      :style="{ opacity: v.state === 0 ? 1 : 0.5 }"
                      v-for="(v, i) of operationData"
                      :key="v.id"
                      @click="operationHanler(v, i)"
                    >
                      <img :src="v.icon" />
                      <div>
                        <p>
                          {{ v.description }}
                        </p>
                        <p class="time">{{ v.createdTime }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="empty" v-else>
                    <img src="~@/assets/images/info_none.png" />
                    <span>暂时没有收到通知!</span>
                  </div>
                </div>
                <div class="operation">
                  <el-checkbox @change="IRelatedChange" v-model="IRelated"
                    >与我相关</el-checkbox
                  >
                  <span @click="operateLogReadAll">全部已读</span>
                </div>
              </div>

              <!-- 版本更新 -->
              <div
                v-show="messageType === 2"
                class="versionCon"
                id="versionConId"
              >
                <div class="isShow" v-if="versionUpdateData.length !== 0">
                  <div
                    class="item"
                    :style="{ opacity: v.state === 0 ? 1 : 0.5 }"
                    v-for="(v, i) of versionUpdateData"
                    :key="v.id"
                    @click="readHanler(v, i)"
                  >
                    <img src="~@/assets/images/info_version.png" />
                    <div>
                      <p>
                        {{
                          v.versionUpdateTime.split(" ")[0] + " " + v.version
                        }}版本更新公告
                      </p>
                      <p class="time">{{ v.versionUpdateTime }}</p>
                    </div>
                  </div>
                </div>
                <div class="empty" v-else>
                  <img src="~@/assets/images/info_none.png" />
                  <span>暂时没有收到通知!</span>
                </div>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 客服微信 -->
        <el-dropdown trigger="click">
          <Icon type="big" name="el-icon-service" content="客服"></Icon>
          <el-dropdown-menu slot="dropdown">
            <div class="customerService">
              <div>
                <img src="~@/assets/images/yewu.png" alt="img" />
                <p>业务咨询客服</p>
              </div>
              <div>
                <img src="~@/assets/images/jishu.jpg" alt="img" />
                <p>技术支持客服</p>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="line"></div>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <img
              :src="userInfomation.profilePhoto"
              alt="img"
              class="avatar"
              v-if="userInfomation.profilePhoto"
            />
            <img
              src="~@/assets/images/head_fill.png"
              alt="img"
              class="avatar"
              v-else
            />
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="avatarDropdown">
              <div class="head">
                <img
                  :src="userInfomation.profilePhoto"
                  alt="img"
                  class="avatar"
                  v-if="userInfomation.profilePhoto"
                />
                <img
                  src="~@/assets/images/head_fill.png"
                  alt="img"
                  class="avatar"
                  v-else
                />
                <el-tooltip
                  :content="nickname"
                  placement="top-start"
                  effect="light"
                  :open-delay="1000"
                >
                  <span class="name">{{ nickname }}</span></el-tooltip
                >
                <span class="phone">{{ userId }}</span>
              </div>
              <div style="height: 15px"></div>
              <div class="btn" @click="goUserCenter">
                <svg
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  style="font-size: 20px; margin-right: 8px"
                >
                  <use xlink:href="#icon-ren1"></use>
                </svg>
                <span>个人中心</span>
              </div>
              <div class="btn" @click="goTeamManagement">
                <!-- <svg
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  style="font-size: 20px; margin-right: 8px"
                >
                  <use xlink:href="#icon-ren1"></use>
                </svg> -->
                <img
                  style="width: 16px; margin: 0 10px 0 2px"
                  src="~@/assets/images/team-set.svg"
                />
                <span>团队管理</span>
              </div>
              <div class="btn" @click="onLogout">
                <svg
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  style="font-size: 20px; margin-right: 8px"
                >
                  <use xlink:href="#icon-sign-out"></use>
                </svg>
                <span>退出登录</span>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <Icon
          type="big"
          name="el-icon-switch-button"
          content="退出"
          @click.native="onLogout"
        ></Icon>
        <Icon type="big" name="icon-dian" content="点"></Icon> -->
      </div>

      <!-- 版本更新公告 -->
      <div v-if="showUpdateInfo" class="updateInfoCon">
        <div class="updateInfo">
          <p class="legend">版本更新公告</p>
          <div class="container">
            <div class="imgBg">
              <img :src="versionContent.url" />
            </div>
            <div class="content" v-html="versionContent.content"></div>
          </div>
          <!-- <div class="content">
              <p class="title">新增功能</p>
              <ul>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
              </ul>
              <p class="title">优化功能</p>
              <ul>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
              </ul>
              <p class="title">优化功能</p>
              <ul>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
                <li>对附件是高科技时代对附件是高科技时代</li>
              </ul>
            </div> -->
          <div class="submit">
            <el-button type="primary" @click="readSubmit">我知道了</el-button>
          </div>
        </div>
      </div>
    </el-header>
  </div>
</template>

<script>
import axios from 'axios'
import { MessageBox } from 'element-ui'
import { mapActions, mapGetters } from 'vuex'
import {
  operationList,
  operateLogRead,
  operateLogReadAll,
  versionList,
  readState,
  existRead,
  operateLogState
} from '@/api/system'
import showdown from 'showdown'
import { dateFtt } from '@/utils/util.js'
// import { PermissionLevel } from '@/configs/constants'
import ReconnectingWebsocket from 'reconnecting-websocket'

export default {
  name: 'GlobalTopNav',
  props: {
    routes: {
      type: Array,
      default: null
    },
    query: {
      type: Object,
      default: null
    },
    mapName: {
      type: String,
      default: ''
    },
    teamEnable: {
      type: Boolean,
      default: true
    }
  },
  inject: ['shared'],
  components: {},
  data () {
    return {
      baseurl: process.env.VUE_APP_API_BASE_URL_WS,
      teamValue: '',
      teamOptions: [],
      activeIndex: 0,

      messageType: 1, // 消息类型 (操作日志--版本更新)
      isHasOpertion: false, // 是否有操作日志消息
      isHasVersion: false, // 是否有版本更新消息
      showUpdateInfo: false, // 是否显示版本更新公告
      operationTypeValue: '', // 操作日志类型选中项
      operationData: [], // 操作日志数据
      operationIcons: [
        { name: '全部', module: '' },
        {
          name: '团队',
          module: 'TEAM',
          icon: require('@/assets/images/info_team.png'),
          path: '/teamManagement'
        },
        {
          name: '地图',
          module: 'MAP',
          icon: require('@/assets/images/info_map.png'),
          path: '/controlPlatform/mapManagement'
        },
        {
          name: '模型',
          module: 'MODEL',
          icon: require('@/assets/images/info_model.png'),
          path: '/controlPlatform/tile'
        },
        {
          name: '区域',
          module: 'AREA',
          icon: require('@/assets/images/info_area.png'),
          path: '/controlPlatform/region'
        },
        {
          name: '数据',
          module: 'DATA',
          icon: require('@/assets/images/info_data.png'),
          path: '/controlPlatform/dataManagement'
        },
        {
          name: '画布',
          module: 'CANVAS',
          icon: require('@/assets/images/info_canvas.png'),
          path: '/controlPlatform/canvasManagement'
        }
      ], // 操作日志图标 以及 操作日志类型选集合
      IRelated: false, // 与我相关
      operationParams: {
        pageNum: 1,
        pageSize: 7,
        relevant: 0, // 是否与我相关1-有关，0-无关
        module: '' // 所属类型
      }, // 版本列表参数
      versionParams: {
        pageNum: 1,
        pageSize: 7
      }, // 版本列表参数
      versionPages: 0, // 版本页数
      operationPages: 0, // 操作日志页数
      versionUpdateData: [], // 版本更新数据
      versionContent: {}, // 最新版本内容
      isOperateListening: false, // 操作日志滚动加载是否正在监听
      isVersionListening: false // 版本滚动加载是否正在监听
    }
  },
  mounted () {
    this.routes.forEach((item, index) => {
      if (item.name === this.$route.name) {
        this.activeIndex = index
      }
    })
    if (!this.shared && !this.isTemplate) {
      this.initWebSocket()
      this.getOperationList()
      this.getVersionList()

      const ele = document.getElementById('operateLogId')
      ele.addEventListener('scroll', this.operateScrollLoading)
      const ele2 = document.getElementById('versionConId')
      ele2.addEventListener('scroll', this.scrollLoading)
    }
  },
  beforeUnmount () {
    if (!this.shared && !this.isTemplate) {
      const ele = document.getElementById('operateLogId')
      ele.removeEventListener('scroll', this.operateScrollLoading)
      const ele2 = document.getElementById('versionConId')
      ele2.removeEventListener('scroll', this.scrollLoading)
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'nickname',
      'userInfomation',
      'isTemplate',
      'permissionLevel'
    ]),
    visibleRoutes () {
      return this.routes.filter((item) => {
        return !item.hidden
      })
    },
    name () {
      return this.data
    }
  },
  watch: {
    $route (to, from) {
      this.routes.forEach((item, index) => {
        if (item.name === to.name) {
          this.activeIndex = index
        }
        // 路由为数据成果，高亮父路由需求管理
        if (to.name === 'EventTable') {
          this.activeIndex = 3
        }
      })
    }
  },
  methods: {
    ...mapActions(['Logout']),
    // websocket消息监听
    initWebSocket () {
      const socket = new ReconnectingWebsocket(
        `${this.baseurl}system/ws/notice?token=${this.userInfomation.id}`
      )
      socket.onopen = () => {
        console.log('ws连接成功')
      }
      socket.onmessage = ({ data }) => {
        console.log('message', data)
        const obj = JSON.parse(data)
        if (obj.module === 'MESSAGE' && obj.body) {
          setTimeout(() => {
            this.getOperationList()
          }, 1000)
        }
      }
    },
    // 打开消息通知 滚动加载监听
    showInfoNotify () {
      this.switchMessage(1)
    },

    // 操作日志--获取操作日志列表
    async getOperationList () {
      this.operationParams.pageNum = 1
      const { data } = await operationList(this.operationParams)
      data.records.forEach((v) => {
        this.operationIcons.forEach((val) => {
          if (v.module === val.module) {
            v.icon = val.icon
          }
        })
        // 时间转换
        v.createdTime = dateFtt('yyyy/MM/dd hh:mm:ss', new Date(v.createdTime))

        // 详情拼接
        const descTemp = JSON.parse(v.description)
        for (const key in descTemp) {
          if (key !== 'template') {
            descTemp.template = descTemp.template.replace(
              `{${key}}`,
              descTemp[key]
            )
          }
        }
        v.description = descTemp.template
      })
      this.operationData = data.records
      this.operationPages = data.pages

      const res = await operateLogState()
      if (res.data === 0) {
        this.isHasOpertion = false
      } else {
        this.isHasOpertion = true
      }
    },

    // 操作日志--类型切换
    operationRefresh (module) {
      document.getElementById('operateLogId').scrollTop = 0
      this.operationParams.module = module
      this.operationParams.pageNum = 1
      this.getOperationList()
    },

    // 操作日志--与我相关
    IRelatedChange (value) {
      document.getElementById('operateLogId').scrollTop = 0
      this.operationParams.pageNum = 1
      this.operationParams.relevant = value ? 1 : 0
      this.getOperationList()
    },

    // 操作日志--全部已读
    async operateLogReadAll () {
      document.getElementById('operateLogId').scrollTop = 0
      this.operationParams.pageNum = 1
      await operateLogReadAll()
      this.getOperationList()
    },

    // 操作日志--点击操作日志列表跳转路由
    async operationHanler (v, i) {
      if (v.state !== 1) {
        await operateLogRead({ operateLogId: v.id })
        this.operationData[i].state = 1
        const res = await operateLogState()
        if (res.data === 0) {
          this.isHasOpertion = false
        } else {
          this.isHasOpertion = true
        }
      }
      this.operationIcons.forEach((val) => {
        if (v.module === val.module && val.path !== this.$route.path) {
          this.$router.push(val.path)
        }
      })
    },

    // 操作日志--滚动加载
    async operateScrollLoading () {
      const el = document.getElementById('operateLogId')
      let isRequesting = false
      // 如果滚动到最底部,加载下一页
      if (el.scrollHeight - el.clientHeight - el.scrollTop === 0) {
        if (isRequesting) return
        if (this.operationParams.pageNum >= this.operationPages) return
        isRequesting = true
        this.operationParams.pageNum++

        const { data } = await operationList(this.operationParams)
        data.records.forEach((v) => {
          this.operationIcons.forEach((val) => {
            if (v.module === val.module) {
              v.icon = val.icon
            }
          })
          // 时间转换
          v.createdTime = dateFtt(
            'yyyy/MM/dd hh:mm:ss',
            new Date(v.createdTime)
          )
          // 详情拼接
          const descTemp = JSON.parse(v.description)
          for (const key in descTemp) {
            if (key !== 'template') {
              descTemp.template = descTemp.template.replace(
                `{${key}}`,
                descTemp[key]
              )
            }
          }
          v.description = descTemp.template
        })
        this.operationData.push(...data.records)
        isRequesting = false
      }
    },

    // 版本更新--获取版本更新列表
    async getVersionList () {
      const { data } = await versionList(this.versionParams)

      this.versionUpdateData = data.records
      this.versionPages = data.pages
      if (data.records[0].state === 0) {
        const convertor = new showdown.Converter()
        const res = await axios.create().get(data.records[0].content)
        data.records[0].content = convertor.makeHtml(res.data)
        this.versionContent = data.records[0]
        this.showUpdateInfo = true
        await readState({ versionId: data.records[0].id })
        data.records[0].state = 1
      }
      const res2 = await existRead()
      if (res2.data === 0) {
        this.isHasVersion = false
      } else {
        this.isHasVersion = true
      }
    },

    // 版本更新--版本更新已读
    async readHanler (v, i) {
      if (v.state !== 1) {
        await readState({ versionId: v.id })
        this.versionUpdateData[i].state = 1
        const { data } = await existRead()
        if (data === 0) {
          this.isHasVersion = false
        } else {
          this.isHasVersion = true
        }
      }
      const convertor = new showdown.Converter()
      axios
        .create()
        .get(v.content)
        .then((req) => {
          const { data } = req
          v.content = convertor.makeHtml(data)
        })
      this.versionContent = v
      this.showUpdateInfo = true
    },

    // 版本更新--滚动加载
    async scrollLoading () {
      const el = document.getElementById('versionConId')
      let isRequesting = false
      // 如果滚动到最底部,加载下一页
      if (el.scrollHeight - el.clientHeight - el.scrollTop === 0) {
        if (isRequesting) return
        if (this.versionParams.pageNum >= this.versionPages) return
        isRequesting = true
        this.versionParams.pageNum++

        const { data } = await versionList(this.versionParams)
        this.versionUpdateData.push(...data.records)
        isRequesting = false
      }
    },

    // 切换消息
    switchMessage (type) {
      this.messageType = type
      document.getElementById('operateLogId').scrollTop = 0
      document.getElementById('versionConId').scrollTop = 0
    },

    // 关闭版本更新弹窗
    readSubmit () {
      this.showUpdateInfo = false
    },

    // 隐藏通知界面
    hideNotice () {
      if (this.$refs && this.$refs.dropdown) {
        this.$refs.dropdown.hide()
      }
    },

    openHelp () {
      window.open('https://www.yuque.com/yaoyikouxueli/ccte31/uab44w')
    },
    async onLogout () {
      if (!this.teamEnable) {
        await this.closeTeamDialog()
      }
      this.$Submit({
        message: '您确定要离开吗？',
        confirm: () => {
          this.Logout().then(() => {
            this.$router.push({ name: 'Login' })
            localStorage.removeItem('teamId')
          })
        },
        cancel: () => {
          // this.getTeamListSelect()
        }
      })
    },
    // screen () {
    //   this.$cesiumPlus.utils.screenCapture(this.$cesiumPlus.viewer.canvas)
    // },
    changePath (index, item) {
      if (this.activeIndex === index || item.hidden) {
        return
      }
      this.activeIndex = index
      this.$router.push({ path: item.path, query: this.query })
      if (!this.teamEnable) this.teamEnableHandler()
    },

    // 前往个人中心
    async goUserCenter () {
      if (!this.teamEnable) {
        await this.closeTeamDialog()
      }
      this.$router.push('/userCenter')
    },

    // 团队过期处理提示框关闭
    closeTeamDialog () {
      document.getElementsByClassName('el-message-box__wrapper')[0].style.top =
        '0px'
      document.getElementsByClassName('v-modal')[0].style.top = '0px'
      MessageBox.close()
    },

    // 团队过期处理提示框展示
    teamEnableHandler () {
      if (
        !this.teamEnable &&
        document.getElementsByClassName('el-message-box__wrapper').length > 0
      ) {
        MessageBox.close()
      }
      this.$confirm('当前团队已过期, 是否立即续费', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '续费',
        closeOnPressEscape: false,
        type: 'warning',
        showCancelButton: false,
        customClass: 'warning'
      })
        .then(() => {
          this.$router.push('/payManagement')
          document.getElementsByClassName(
            'el-message-box__wrapper'
          )[0].style.top = '0px'
          document.getElementsByClassName('v-modal')[0].style.top = '0px'
        })
        .catch(() => {})
      setTimeout(() => {
        document.getElementsByClassName(
          'el-message-box__wrapper'
        )[0].style.top = '47px'
        document.getElementsByClassName('v-modal')[0].style.top = '47px'
      })
    },

    // 前往团队管理
    async goTeamManagement () {
      if (!this.teamEnable) {
        await this.closeTeamDialog()
      }
      this.$router.push('/teamManagement')
    }
  }
}
</script>

<style lang="scss">
.globalTopNav {
  p {
    margin: 0;
  }
  font-family: Source Han Sans SC;
  box-sizing: border-box;
  width: 100%;
  .el-header {
    height: 48px !important;
    background: #272829;
    box-sizing: border-box;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .line {
      width: 1px;
      height: 28px;
      background: rgba(255, 255, 255, 0.1);
    }
    .left {
      width: 260px;
      height: 100%;
      padding: 4px 0 4px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      text-align: left;
      position: relative;
      .el-select {
        width: 200px;
        input {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .el-select-dropdown__wrap.el-scrollbar__wrap {
        max-height: 176px;
        margin-right: 0 !important;
        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
      }
      .el-select-dropdown.el-popper {
        width: 200px;
        max-height: 212px;
        padding-bottom: 36px;
      }
      .el-scrollbar {
        overflow: visible;
      }
      .TeamEnter {
        width: 200px;
        height: 36px;
        padding: 0 19px;
        margin: 0;
        font-size: 12px;
        border-top: 2px solid rgba(255, 255, 255, 0.1);
        color: #fff;
        position: absolute;
        bottom: -36px;
        background: #474849;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .el-icon-right {
          width: 17px;
          height: 17px;
          text-align: center;
          line-height: 17px;
          background: #666769;
          border-radius: 50%;
        }
      }
      .mapNameLooker {
        width: 100%;
        height: 28px;
        display: flex;
        align-items: center;
        font-family: Source Han Sans SC;
        margin-left: 10px;
        border-left: 1px solid rgba(255, 255, 255, 0.14);
        .img {
          width: 28px;
          height: 28px;
          line-height: 24px;
          border-radius: 5px;
          margin-left: 5px;
          text-align: center;
          cursor: pointer;
          img {
            width: 12px;
          }
        }
        .img:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        span {
          font-size: 14px;
          max-width: 168px;
          margin-left: 5px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .center {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 10px;
      box-sizing: border-box;
      .line {
        width: 1px;
        height: 28px;
        background: rgba(255, 255, 255, 0.1);
        margin-left: 12px;
      }
      .nav {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.3);
        font-family: Source Han Sans SC;
        font-weight: 300;
        cursor: pointer;
        margin-left: 10px;
        width: 90px;
        height: 32px;
        line-height: 32px;
        transition: all 0.3s;
        &:hover {
          color: #ffffff;
        }
        &.active {
          background: #00a4f0;
          border-radius: 16px;
          color: #ffffff;
        }
      }
      .el-dropdown {
        .el-dropdown-link {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.3);
          font-family: Source Han Sans SC;
          font-weight: 300;
        }
      }
    }
    .right {
      width: 260px;
      height: 100%;
      padding-left: 57px;
      padding-right: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      position: relative;
      .messageIcon {
        position: relative;
        &:before {
          content: "";
          display: inline-block;
          position: absolute;
          top: 3px;
          right: 4px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #ff3f3f;
        }
      }
      .avatar {
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
      }
    }
    .updateInfoCon {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      .updateInfo {
        width: 540px;
        // height: 700px;
        background: #3d3e40;
        border: 1px solid #565759;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
        border-radius: 12px;
        text-align: left;
        font-size: 14px;
        .legend {
          font-size: 16px;
          font-weight: 400;
          margin: 20px 0 20px 20px;
        }
        .container {
          max-height: 570px;
          overflow: auto;
          .imgBg {
            padding: 0 20px 20px 20px;
            img{
              width: 100%;
            }
          }
          .content {
            padding: 0 20px;
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
              color: #fff;
            }
            ul,
            ol {
              padding-left: 20px;
              li {
                line-height: 30px;
              }
            }
            p {
              margin-bottom: 14px;
            }
            .title {
              font-size: 16px;
              margin-bottom: 5px;
            }
          }
        }
        .submit {
          margin: 13px 20px 20px 0;
          text-align: right;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.messageNotice {
  p {
    margin: 0;
  }
  width: 400px;
  height: 500px;
  background: #303030;
  border: 1px solid #47484a;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  position: absolute;
  top: 15px;
  right: -10px;
  z-index: 98;
  font-size: 14px;
  color: #fff;
  text-align: left;
  .title {
    height: 49px;
    margin: 0 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    color: #999999;
    display: flex;
    align-items: center;
    & > div {
      margin-right: 50px;
      cursor: pointer;
      .el-badge__content.is-dot {
        width: 5px;
        height: 5px;
        background: #ff3f3f;
        padding: 0;
        right: 0;
        border-radius: 50%;
        border: none;
      }
      .active {
        color: #fff;
      }
    }
    .progress {
      position: absolute;
      bottom: 0;
      left: 13px;
      width: 32px;
      height: 2px;
      background: #00a4f0;
      border-radius: 1px;
      transition: transform 0.3s;
    }
  }
  .operationCon {
    // height: 410px;
    margin: 10px 0 0 10px;
    .selectTypeCon {
      width: 75px;
      .el-input__inner {
        background: transparent;
        border: 0;
        outline: none;
        box-shadow: none;
      }
      .el-select-dropdown.el-popper {
        width: 140px;
      }
    }
    .contentCon {
      height: 354px;
      overflow: auto;
      &::-webkit-scrollbar {
        background: transparent;
      }
      &::-webkit-scrollbar-track {
        border-radius: 5px;
      }
      .isShow {
        height: 100%;
        .item {
          // height: 65px;
          display: flex;
          padding: 13px 10px;
          align-items: flex-start;
          border-radius: 6px;
          cursor: pointer;
          img {
            margin: 4px 12px 0 0;
          }
          .time {
            font-size: 12px;
            color: #999999;
          }
        }
        .item:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
      .empty {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          letter-spacing: 1px;
          color: #a5a5a6;
          margin-top: 10px;
        }
      }
    }
    .operation {
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 18px 0 8px;
      .el-checkbox__inner {
        width: 14px;
        height: 14px;
      }
      .el-checkbox__label {
        font-size: 12px;
      }
      span {
        color: #00a4f0;
        cursor: pointer;
      }
      span:hover {
        opacity: 0.8;
      }
    }
  }
  .versionCon {
    height: 410px;
    overflow: auto;
    margin: 18px 0 0 10px;
    &::-webkit-scrollbar {
      background: transparent;
    }
    &::-webkit-scrollbar-track {
      border-radius: 5px;
    }
    .isShow {
      height: 100%;
      .item {
        // height: 65px;
        display: flex;
        padding: 13px 10px;
        align-items: flex-start;
        border-radius: 6px;
        cursor: pointer;
        img {
          margin: 4px 12px 0 0;
        }
        .time {
          font-size: 12px;
          color: #999999;
        }
      }
      .item:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span {
        letter-spacing: 1px;
        color: #a5a5a6;
        margin-top: 10px;
      }
    }
  }
}
.customerService {
  p {
    margin: 0;
  }
  width: 236px;
  height: 153px;
  padding-top: 15px;
  background: #303030;
  border: 1px solid #47484a;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  position: absolute;
  top: 15px;
  right: -12px;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  & > div {
    font-size: 12px;
    color: #bbbbbb;
    letter-spacing: 1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    img {
      width: 80px;
      border-radius: 4px;
      margin-bottom: 12px;
    }
  }
}
.avatarDropdown {
  width: 240px;
  // height: 180px;
  background: #303030;
  border: 1px solid #47484a;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  position: absolute;
  top: 15px;
  z-index: 1000;
  right: 5px;
  box-sizing: border-box;
  padding: 20px;
  padding-top: 20px;
  .head {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-align: left;
    position: relative;
    padding-bottom: 18px;
    > img {
      width: 35px;
      height: 35px;
      display: inline-block;
      border-radius: 50%;
    }
    > span {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #ffffff;
      &.phone {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #999999;
        position: absolute;
        top: 20px;
        left: 45px;
      }
      &.name {
        width: 153px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: absolute;
        top: 0px;
        left: 45px;
      }
    }
  }
  .btn {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #bbbbbb;
    display: flex;
    align-items: center;
    justify-content: start;
    height: 40px;
    cursor: pointer;
    > i {
      margin-right: 5px;
    }
    &:hover {
      color: #00a4f0;
    }
  }
}
</style>
